import React from 'react';
import { Button } from '../components/ui/button';
import { Music4, Download, ExternalLink } from 'lucide-react';
import { mixGenres, SOCIAL } from '../mock';

export default function Mixes() {
  return (
    <section id="mixes" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="absolute top-1/2 left-0 w-[500px] h-[500px] rounded-full bg-violet-800/10 blur-[130px]" />

      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="flex items-center gap-3 font-mono text-[11px] tracking-[0.3em] text-violet-300/70 uppercase mb-6">
              <span className="h-px w-10 bg-violet-400/50" />
              <span>Mix Catalogue · Music Library</span>
            </div>
            <h2 className="font-display text-6xl md:text-7xl lg:text-8xl leading-[0.9] mb-8">
              <span className="text-white">150+ </span>
              <span className="text-gradient-purple italic">MIXES</span>
              <span className="block text-white">ON DEMAND</span>
            </h2>
            <p className="text-white/60 leading-relaxed mb-4 max-w-lg">
              A 1.5-year growing catalogue of <span className="text-white">150+ original mixes</span> recorded live on <span className="text-white">rekordbox</span> — spanning Bollywood, Afro House, Hip-Hop, Rock Remixes, Commercial, and more.
            </p>
            <p className="text-white/60 leading-relaxed mb-8 max-w-lg">
              Backed by a <span className="text-white">240+ GB library</span> of downloaded tracks covering every genre, language, and occasion — so no request is ever out of reach. Request any mix for free download.
            </p>
            <div className="flex flex-wrap gap-3">
              <Button asChild className="bg-violet-400 text-[#1a0b2e] hover:bg-violet-300 rounded-none font-mono text-[11px] tracking-[0.25em] uppercase h-12 px-6">
                <a href={SOCIAL.drive} target="_blank" rel="noreferrer">Browse All Mixes</a>
              </Button>
              <Button asChild variant="outline" className="bg-transparent border-violet-400/40 text-violet-100 hover:bg-violet-500/10 hover:text-violet-100 rounded-none font-mono text-[11px] tracking-[0.25em] uppercase h-12 px-6">
                <a href={SOCIAL.instagram} target="_blank" rel="noreferrer">Request a Mix</a>
              </Button>
            </div>
          </div>

          {/* Right visual card */}
          <div className="relative">
            <div className="relative rounded-lg border border-violet-500/25 bg-gradient-to-br from-violet-950/50 to-[#0a0612] p-8 overflow-hidden">
              <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-violet-500/20 blur-[80px]" />
              <div className="relative">
                <div className="grid grid-cols-2 gap-3 mb-6">
                  {mixGenres.map((g) => (
                    <div key={g.title} className="p-4 rounded border border-violet-500/15 bg-black/30">
                      <div className="w-9 h-9 rounded-full bg-violet-500/15 border border-violet-400/30 flex items-center justify-center mb-3">
                        <Music4 className="w-4 h-4 text-violet-300" />
                      </div>
                      <div className="font-display text-sm tracking-wider text-white mb-1">{g.title}</div>
                      <div className="text-[11px] text-white/45">{g.desc}</div>
                    </div>
                  ))}
                </div>
                <div className="flex items-center justify-between border-t border-violet-500/15 pt-6">
                  <div>
                    <div className="font-display text-5xl text-gradient-purple">150+</div>
                    <div className="font-mono text-[10px] tracking-[0.25em] text-violet-300/60 uppercase mt-1">Original Mixes · Free on Request</div>
                  </div>
                  <a href={SOCIAL.drive} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] text-violet-300 hover:text-violet-200 uppercase">
                    Open Drive <ExternalLink className="w-3 h-3" />
                  </a>
                </div>
              </div>
            </div>

            {/* Floating stat */}
            <div className="absolute -bottom-8 -left-6 hidden md:flex items-center gap-3 px-5 py-3 rounded-full bg-[#0a0612] border border-violet-400/40 shadow-lg">
              <Download className="w-4 h-4 text-violet-300" />
              <span className="font-mono text-[10px] tracking-[0.2em] text-violet-200 uppercase">Free DL · On Request</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
